export default function getDataValueReduxUtil (instanceOrPojo, key) {
  const hasProperty = instanceOrPojo?.data && (
    Object.prototype.hasOwnProperty.call(instanceOrPojo?.data, key)
  )
  if (!hasProperty) {
    return
  }
  return instanceOrPojo?.data[key]
}
